import {
  DeleteReserveRequestReserve,
  DeleteReserveRequestReserveFromJSON,
  DeleteReserveRequestReserveToJSON,
  exists
} from '@/api'

export interface DeleteReserveRequest {
  reserves: DeleteReserveRequestReserve[]
  reason: string
  memo: string
  canceler: string
}

export function DeleteReserveRequestFromJSON(json: any): DeleteReserveRequest {
  return DeleteReserveRequestFromJSONTyped(json)
}

export function DeleteReserveRequestFromJSONTyped(
  json: any
): DeleteReserveRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    reserves: json.reserves.map(DeleteReserveRequestReserveFromJSON),
    reason: exists(json, 'reason') ? json.reason : '',
    memo: exists(json, 'memo') ? json.memo : '',
    canceler: exists(json, 'canceler') ? json.canceler : ''
  }
}

export function DeleteReserveRequestToJSON(value: DeleteReserveRequest): any {
  return {
    reserves: value.reserves.map(DeleteReserveRequestReserveToJSON),
    reason: value.reason,
    memo: value.memo,
    canceler: value.canceler
  }
}
